var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',[(_vm.state === 'loading')?_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_c('v-calendar',{class:_vm.state === 'loading' ? '' : 'mt-3',attrs:{"now":_vm.today,"color":"primary","events":_vm.rates,"start":_vm.curMonth.start,"end":_vm.curMonth.end}}),_c('ErrorDialog',{ref:"errorDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }